@if (pageVersion) {
  <div class="product-options">
    <app-product-info [productInfoTitle]="title"></app-product-info>
    <div class="product-reasons-grid">
      @for (card of cards; track card) {
        <app-product-option [card]="card"></app-product-option>
      }
    </div>
  </div>
}